<template>
  <page-container>
    <el-tabs v-model="sqlcode" type="border-card" @tab-click="refresh" style="margin:10px;">
      <el-tab-pane label="用户管理" name="user_list">
        <div style="padding:10px">
          <el-button type="primary" @click="add">Add User</el-button>
          <el-button type="success" @click="changePassword2">Change Company ID</el-button>
        </div>
        <el-table
          :data="list"
          stripe
          border
          :row-class-name="tableRowClassName"
          style="width:100%">
          <el-table-column
            prop="id"
            label="ID"
            width="80">
          </el-table-column>
          <el-table-column
            prop="username"
            label="Account"
            width="120">
          </el-table-column>
          <el-table-column
            prop="realname"
            label="Name"
            width="120">
          </el-table-column>
          <el-table-column
            prop="rolename"
            label="Role"
            width="100">
          </el-table-column>
          <el-table-column
            prop="hire_date"
            label="Hire Date"
            width="140">
          </el-table-column>
          <el-table-column
            prop="leave_date"
            label="Leave Date"
            width="140">
          </el-table-column>
          <el-table-column
            prop="allow_time"
            label="Allow Time"
            width="100">
          </el-table-column>
          <el-table-column
            prop="status"
            label="Status"
            width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.error_count < 5">{{ scope.row.is_del === '0' ? 'Enable' : 'Disable' }}</span>
              <el-button v-else type="text" style="color:#E6A23C;" @click="resetErrorCount(scope.row.id)">Locked</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="Action">
            <template slot-scope="scope">
              <el-button type="text" v-if="scope.row.is_del === '0'" @click="edit(scope.row)">Edit</el-button>
              <el-button type="text" v-if="scope.row.is_del === '0'" @click="changePassword(scope.row)">Change Password</el-button>
              <el-button type="text" v-if="scope.row.is_del === '0'" @click="changeEmail(scope.row)">Email Config</el-button>
              <el-button type="text" v-if="scope.row.is_del === '0'" @click="disable(scope.row)" style="color:#f56c6c;">Disable</el-button>
              <el-button type="text" v-else @click="enable(scope.row)">Enable</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, pager" 
          :total="total">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="登录日志" name="user_login_list">
        <el-table
          :data="list"
          stripe
          border
          :row-class-name="tableRowClassName"
          style="width:100%">
          <el-table-column
            prop="username"
            label="Account"
            width="120">
          </el-table-column>
          <el-table-column
            prop="realname"
            label="Name"
            width="120">
          </el-table-column>
          <el-table-column
            prop="login_time"
            label="Login Time"
            width="180">
          </el-table-column>
          <el-table-column
            prop="ip"
            label="IP">
            <template slot-scope="scope">
              <a :href="'http://www.ip138.com/ips138.asp?ip=' + scope.row.ip" target="_blank">{{ scope.row.ip }}</a>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-sizes="[20, 50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, pager" 
          :total="total">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>
    <!-- Add User -->
    <el-dialog title="Edit User/Sales" :visible.sync="formVisible">
      <el-form :model="form" ref="form" label-width="200px">
        <el-form-item label="Account" prop="username" required>
          <el-input v-model="form.username" style="width:194px"></el-input>
        </el-form-item>
        <el-form-item label="Name" prop="realname" required>
          <el-input v-model="form.realname" style="width:194px"></el-input>
        </el-form-item>
        <el-form-item label="Role" prop="role_id" required>
          <el-select
            v-model="form.role_id"
            placeholder="select role"
            style="width:194px;">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Hire Date">
          <el-date-picker v-model="form.hire_date" type="date" value-format="yyyy-MM-dd" style="width:194px"></el-date-picker>
        </el-form-item>
        <el-form-item label="Leave Date" v-if="form.id > 0">
          <el-date-picker v-model="form.leave_date" type="date" value-format="yyyy-MM-dd" style="width:194px"></el-date-picker>
        </el-form-item>
        <el-form-item label="Allow Time">
          <div flex>
            <el-time-select
              placeholder="起始时间"
              style="width:120px"
              v-model="form.allow_time_start"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:00'
              }">
            </el-time-select>
            &nbsp;-&nbsp;
            <el-time-select
              placeholder="结束时间"
              style="width:120px"
              v-model="form.allow_time_end"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
                minTime: form.allow_time_start
              }">
            </el-time-select>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit" :loading="commiting">Save</el-button>
        <el-button @click="formVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码 -->
    <el-dialog title="Change Password" :visible.sync="passwordFormVisible">
      <el-form :model="passwordForm" ref="passwordForm" :rules="passwordFormRules" label-width="200px">
        <el-form-item label="新密码" prop="newpass">
          <el-input type="password" v-model="passwordForm.newpass" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="再次输入新密码" prop="newpass2">
          <el-input type="password" v-model="passwordForm.newpass2" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="passwordFormCommit" :loading="passwordFormCommiting">Save Changes</el-button>
        <el-button @click="passwordFormVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
    <!-- 配置邮箱 -->
    <el-dialog title="Email Config" :visible.sync="emailFormVisible">
      <el-form :model="emailForm" ref="emailForm" :rules="emailFormRules" label-width="200px">
        <el-form-item label="Email" prop="email">
          <el-input v-model="emailForm.email" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="email_pass">
          <el-input type="password" v-model="emailForm.email_pass" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="emailFormCommit" :loading="emailFormCommiting">Save Changes</el-button>
        <el-button @click="emailFormVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
    <!-- Company ID -->
    <el-dialog title="Change Company ID" :visible.sync="password2FormVisible">
      <el-form :model="password2Form" ref="password2Form" label-width="200px">
        <el-form-item label="Company ID" prop="password2">
          <el-input type="password" v-model="password2Form.password2" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="Re-enter Company ID">
          <el-input type="password" v-model="password2Form.password2_re" style="width:194px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="password2FormCommit" :loading="password2FormCommiting">Save Changes</el-button>
        <el-button @click="password2FormVisible = false">Cancel</el-button>
      </div>
    </el-dialog>
  </page-container>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import md5 from 'md5'
export default {
  mixins: [ListFunc],
  data () {
    return {
      sqlcode: 'user_list',
      searchForm: {
        query: ''
      },
      form: {
        id: 0,
        username: '',
        realname: '',
        role_id: 3,
        hire_date: '',
        leave_date: '',
        allow_time_start: '',
        allow_time_end: ''
      },
      formVisible: false,
      commiting: false,
      passwordForm: {
        id: 0,
        //oldpass: '',
        newpass: '',
        newpass2: ''
      },
      passwordFormVisible: false,
      passwordFormRules: {
        /*
        oldpass: [
          { required: true, message: 'Required', trigger: 'blur' }
        ],
        */
        newpass: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('必填项'));
              } else {
                if (this.passwordForm.newpass2 !== '') {
                  this.$refs.passwordForm.validateField('newpass2')
                }
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        newpass2: [
          {
            validator: (rule, value, callback) => {
              if (value === '') {
                callback(new Error('必填项'))
              } else if (value !== this.passwordForm.newpass) {
                callback(new Error('两次输入密码不一致'))
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      },
      passwordFormCommiting: false,
      emailForm: {
        id: 0,
        email: '',
        email_pass: ''
      },
      emailFormVisible: false,
      emailFormRules: {
        email: [
          { required: true, message: '请输入Email', trigger: 'blur' }
        ],
        email_pass: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      emailFormCommiting: false,
      password2Form: {
        password2: '',
        password2_re: ''
      },
      password2FormVisible: false,
      password2FormCommiting: false,
      roleList: [],
      pageSize: 20
    }
  },
  mounted () {
    this.fetchList()
    this.fetchRoleList()
  },
  methods: {
    tableRowClassName ({row, rowIndex}) {
      if (row.is_del === '1') {
        return 'row-red'
      } else {
        return ''
      }
    },
    fetchRoleList () {
      this.$http.get('/dbapi/role_list').then(data => {
        this.roleList = data.list
      })
    },
    add () {
      this.form = {
        id: 0,
        username: '',
        realname: '',
        role_id: 3,
        hire_date: new Date(),
        leave_date: '',
        allow_time_start: '00:00',
        allow_time_end: '23:45'
      }
      this.formVisible = true
    },
    edit (row) {
      this.form = {
        id: row.id,
        username: row.username,
        realname: row.realname,
        role_id: row.role_id,
        hire_date: row.hire_date,
        leave_date: row.leave_date,
        allow_time_start: row.allow_time.substr(0, 5),
        allow_time_end: row.allow_time.substr(6, 5)
      }
      this.formVisible = true
    },
    commit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.commiting = true
          let url = '/dbapi/user_insert'
          if (this.form.id > 0) {
            url = '/dbapi/user_update'
          }
          this.form.allow_time = this.form.allow_time_start + '-' + this.form.allow_time_end 
          this.$http.post(url, this.form).then(data => {
            this.commiting = false
            this.formVisible = false
            this.refresh()
            this.$message({
              type: 'success',
              message: 'Saved Successfully'
            })
          }).catch(() => this.commiting = false)
        }
      })
    },
    /*
    reset (row) {
      this.$confirm('Reset password for this user ?', 'Confirm', {
        confirmButtonText: 'Reset',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/user_reset_password', {
          id: row.id
        }).then(data => {
          this.$message({
            type: 'success',
            message: 'Password is reset to 123456'
          })
          this.refresh()
        })
      })
    },
    */
    changePassword (row) {
      this.passwordForm.id = row.id
      this.passwordFormVisible = true
    },
    passwordFormCommit () {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.passwordFormCommiting = true
          this.$http.post('/dbapi/user_update_password', {
            id: this.passwordForm.id,
            newpass: md5(this.passwordForm.newpass)
          }).then(data => {
            this.passwordFormCommiting = false
            this.$refs.passwordForm.resetFields()
            this.passwordFormVisible = false
            this.$message({
              type: 'success',
              message: '密码修改成功'
            })
          }).catch(() => this.passwordFormCommiting = false)
        }
      })
    },
    changeEmail (row) {
      this.emailForm.id = row.id
      this.emailForm.email = row.email
      this.emailForm.email_pass = row.email_pass
      this.emailFormVisible = true
    },
    emailFormCommit () {
      this.$refs.emailForm.validate(valid => {
        if (valid) {
          this.emailFormCommiting = true
          this.$http.post('/dbapi/user_update_email', this.emailForm).then(data => {
            this.emailFormCommiting = false
            // this.$refs.emailForm.resetFields()
            this.emailFormVisible = false
            this.$message({
              type: 'success',
              message: 'Email修改成功'
            })
            this.refresh()
          }).catch(() => this.emailFormCommiting = false)
        }
      })
    },
    changePassword2 () {
      if (this.list.length > 0) {
        this.password2Form.password2 = this.list[0].password2
      }
      this.password2FormVisible = true
    },
    password2FormCommit () {
      if (this.password2Form.password2 !== this.password2Form.password2_re) {
        this.$message({
          type: 'error',
          message: '两次输入不一致'
        })
        return
      }
      this.password2FormCommiting = true
      this.$http.post('/dbapi/user_update_password2', this.password2Form).then(data => {
        this.password2FormCommiting = false
        this.password2FormVisible = false
        this.$message({
          type: 'success',
          message: 'Company ID修改成功'
        })
        this.refresh()
      }).catch(() => this.password2FormCommiting = false)
    },
    disable (row) {
      this.$confirm('Disable this user ?', 'Confirm', {
        confirmButtonText: 'Disable',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/user_disable', {
          id: row.id
        }).then(data => {
          this.$http.post('/auth/del_user', { id: row.id })
          this.$message({
            type: 'success',
            message: 'Saved Successfully'
          })
          this.refresh()
        })
      })
    },
    enable (row) {
      this.$confirm('Enable this user ?', 'Confirm', {
        confirmButtonText: 'Enable',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/user_enable', {
          id: row.id
        }).then(data => {
          this.$message({
            type: 'success',
            message: 'Saved Successfully'
          })
          this.refresh()
        })
      })
    },
    resetErrorCount (id) {
      this.$http.post('/dbapi/user_reset_error_count', { id }).then(data => {
        this.$message({
          type: 'success',
          message: '操作成功'
        })
        this.refresh()
      })
    }
  }
}
</script>
